import React, { Component } from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { removeCookie } from '../../common/utils';

class UserInfo extends Component {
	render() {
		const { user } = this.props;
		return (
			<div className="user-info">
				<h2>User Information</h2>
				<p>
					<b>Email: </b>
					{user.email}
				</p>
				<p>
					<b>Username: </b>
					{user.username}
				</p>
				<Button type="danger">
					<Link
						to={{ pathname: '/', state: { isLogout: true } }}
						onClick={() => {
							removeCookie('id_token');
							removeCookie('email');
						}}
					>
						Logout
					</Link>
				</Button>
			</div>
		);
	}
}
export default UserInfo;
